import { render } from "./AdditionDynamique.vue?vue&type=template&id=5246af90&scoped=true"
import script from "./AdditionDynamique.vue?vue&type=script&lang=js"
export * from "./AdditionDynamique.vue?vue&type=script&lang=js"

import "./AdditionDynamique.vue?vue&type=style&index=0&id=5246af90&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5246af90"]])

export default __exports__